import { useAnalytics } from 'libs/utils/site/analytics';
import { CustomMapPage } from 'pages/custom/shared/CustomMapPage';
import { OverflowFilters } from 'pages/custom/shared/overflow/OverflowFilters';
import { S_PageStyle } from 'pages/page/PageStyle';
import { useContext, useEffect } from 'react';
import { CtxView } from 'session/ctxView';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const Kontakt2024Page = (props: Props): JSX.Element => {
    const ctxView = useContext(CtxView);
    const analytics = useAnalytics();

    useEffect(() => {
        ctxView.setCustomPageConfig({
            storyIdsExcludedInList: [
                'e6e55f22-c0b1-4064-9be1-243adb6d9d13',
                'c6c5afa8-e844-4031-8d61-fbe789f283b4',
                '2b2f9d9a-cc2c-4aaf-9088-c81c955bb4df',
                'cc11074d-f159-4253-913e-41f4153d1ab7',
                '6ea01505-ee22-445d-b389-359da0c44e97',
                'b14ed205-f698-4a10-ac20-9d144fe89ec5',
                '62eb7f41-81fc-4b75-a6a9-5d346c9e8e55'
            ]
        });

        Localization.setLanguage('cs');
    }, []);

    function isSetHighlighted(mapSetId: string) {
        return ctxView.visibleMapSetIds.includes(mapSetId);
    }

    const suteren = 'fb5ad349-dda1-4b69-81e9-84ce0f8f4e3b';
    const prizemi = 'dbcf53e0-f5b1-4e7d-8a96-19576a0a8939';
    const patro = '0f55b131-b36d-42d2-8746-62686270cb76';

    function setVisibleMapSetAndHideOthers(mapSetId: string) {
        const visible = ctxView.visibleMapSetIds;
        const newVisible = visible.filter((id) => id !== suteren && id !== prizemi && id !== patro);
        newVisible.push(mapSetId);
        ctxView.setVisibleMapSetIds(newVisible);

        analytics.track('floor_button.clicked', {
            building: 'aula',
            source: 'custom_buttons',
            floorId: mapSetId
        });
    }

    return (
        <S_UIAPage className={props.className}>
            <CustomMapPage
                mapId={'88353fa3-e293-46e1-8b90-6faf7436b0f4'}
                mapProps={{
                    light: {
                        anchor: 'viewport',
                        color: '#ccc',
                        intensity: 0.1
                    }
                }}
                header={{
                    logo: 'https://dvtqxks0zalev.cloudfront.net/c9ce845a-608e-4eb5-a1f4-67a421c1c304.png',
                    link: 'https://www.upce.cz/kontakt-2020-0',
                    linkText: Localization.WEBSITE
                }}
                hideFloors
                topOverflow={
                    <OverflowFilters
                        highlightedBackground="linear-gradient(88.56deg,#bc4e4e 0%,#a31616 100%)"
                        items={[
                            {
                                iconName: 'layer-group',
                                text: 'Aula Suterén',
                                onClick: () => {
                                    setVisibleMapSetAndHideOthers(suteren);
                                },
                                highlighted: isSetHighlighted(suteren)
                            },
                            {
                                iconName: 'layer-group',
                                text: 'Aula Přízemí',
                                onClick: () => {
                                    setVisibleMapSetAndHideOthers(prizemi);
                                },
                                highlighted: isSetHighlighted(prizemi)
                            },
                            {
                                iconName: 'layer-group',
                                text: 'Aula 1. patro',
                                onClick: () => {
                                    setVisibleMapSetAndHideOthers(patro);
                                },
                                highlighted: isSetHighlighted(patro)
                            }
                        ]}
                    />
                }
            />
        </S_UIAPage>
    );
};

const S_UIAPage = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
`;
